export default __webpack_public_path__ + "static/media/IMG_085_fin.0f640dd1.jpg";